import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, first, map, Observable, of, switchMap } from 'rxjs';

import { ApiErrorMessage } from '@features/succession/interfaces';

import { selectCustomerInformationErrorCode } from '../store';

const checkStore = (store: Store): Observable<string | undefined> =>
  store.select(selectCustomerInformationErrorCode);

export const ApiErrorResolver = (): Observable<ApiErrorMessage> => {
  const store = inject(Store);
  const translate = inject(TranslateService);

  return checkStore(store).pipe(
    switchMap((code?: string | undefined) =>
      combineLatest([of(code), translate.get(`error.${code}`)]),
    ),
    map(([code, error]) => {
      if (typeof error === 'string' || typeof error === 'undefined') {
        return 'DEFAULT';
      }
      return code;
    }),
    switchMap((code) =>
      translate.get(`error.${code}`).pipe(
        map(
          (error: ApiErrorMessage) =>
            ({
              ...error,
              code,
            }) as ApiErrorMessage,
        ),
      ),
    ),
    first(),
  );
};
